import { useApp } from "./AppContext";
import { X, GitCompareArrows } from "lucide-react";
import { Link } from "react-router-dom";

const CompareBar = () => {
  const { compareList, toggleCompare, clearCompare, t } = useApp();
  if (!compareList.length) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-neutral-200 shadow-2xl shadow-black/10 px-6 py-4 animate-fade-in-up" data-testid="compare-bar">
      <div className="max-w-[1400px] mx-auto flex items-center gap-4">
        <div className="flex items-center gap-2 flex-shrink-0">
          <GitCompareArrows size={18} className="text-[#C9A84C]" />
          <span className="text-sm font-semibold text-[#111]">{t('compare')} ({compareList.length}/4)</span>
        </div>
        <div className="flex gap-3 flex-1 overflow-x-auto no-scrollbar">
          {compareList.map(p => (
            <div key={p.id} className="flex items-center gap-2 bg-neutral-50 rounded-full pl-1 pr-3 py-1 flex-shrink-0 border border-neutral-100">
              <img src={p.image} alt="" className="w-8 h-8 rounded-full object-cover" />
              <span className="text-xs text-neutral-700 max-w-[120px] truncate">{p.name}</span>
              <button onClick={() => toggleCompare(p)} className="text-neutral-400 hover:text-red-500 transition-colors" data-testid={`compare-remove-${p.id}`}>
                <X size={12} />
              </button>
            </div>
          ))}
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button onClick={clearCompare} className="text-xs text-neutral-400 hover:text-neutral-700 transition-colors px-3 py-2" data-testid="compare-clear">
            {t('clearAll')}
          </button>
          <Link to="/compare" className="px-6 py-2.5 bg-[#1a1a1a] text-white text-xs font-semibold rounded-full hover:bg-[#333] transition-colors" data-testid="compare-view-btn">
            {t('compareProducts')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
